/**
 *  komponenta pro štítky pro produkty
 */
import React, { Fragment, useState } from "react";
import AddEditOrganiserAdminUser from "./AddEditOrganiserAdminUser";
import ModalNotification from "../../../GlobalComponents/ModalNotification";
import Notification from "../../../Library/notification";
import { useQuery, useMutation } from "@apollo/client";
import { GET_ORGANISER_ADMIN_USERS, DELETE_ORGANISER_ADMIN_USERS } from "../Queries/organiser";
import Loading from "../../../GlobalComponents/Loading";
import Error from "../../../GlobalComponents/Error";
import edit from "../../../Public/Images/edit.svg";
import NoItems from "../../../GlobalComponents/NoItems";
import Helper from "../../../Library/helper";
import translate from "../../Translations/index";

const OrganiserAdminUserList = (props) => {
    const [selectedOrganiserAdminUsers, setSelectedOrganiserAdminUsers] = useState([]);
    const [showDeleteNotifi, setShowDeleteNotifi] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [selectedOrganiserAdminUserID, setSelectedOrganiserAdminUserID] = useState("");

    const {
        loading,
        error: getError,
        data: organiserAdminUserListData,
        fetchMore,
        refetch,
    } = useQuery(GET_ORGANISER_ADMIN_USERS, {
        variables: {
            organiserID: props.organiserID,
        },
        fetchPolicy: "cache-and-network",
    });

    const [deleteOrganiserAdminUser, { data, loading: deleteLoading, error: deleteError }] = useMutation(DELETE_ORGANISER_ADMIN_USERS, {
        update(cache, response) {
            let notify = new Notification();
            notify.setNotification(translate.t("SuccessFullyDeleted"));
            setShowDeleteNotifi(false);
            refetch();
        },
        onError(err) {
            const helper = new Helper();
            let notify = new Notification();
            notify.setNotification(helper.getApolloErrorText(err), "danger");
        },
    });

    const openCloseModal = (open, organiserAdminUserID) => {
        setSelectedOrganiserAdminUserID(organiserAdminUserID);
        setShowAdd(open);
    };

    /**
     * smazání štítků
     * @param {*} deleteOrganiserAdminUsers funkce, která posílá data na server
     * @param {*} organiserAdminUserID ID organiserAdminUseru
     */

    const initiateDeleteOrganiserAdminUser = (e, organiserAdminUserID) => {
        var checked = e.target.checked;
        var arr = [...selectedOrganiserAdminUsers];

        if (!checked) {
            for (let i in selectedOrganiserAdminUsers) {
                if (selectedOrganiserAdminUsers[i] == organiserAdminUserID) {
                    arr.splice(i, 1);
                }
            }
        } else {
            arr = [organiserAdminUserID, ...arr];
        }

        setSelectedOrganiserAdminUsers(arr);
    };

    const delOrganiserAdminUser = (action) => {
        if (action) {
            let organiserAdminUserIDs = selectedOrganiserAdminUsers.join(",");

            deleteOrganiserAdminUser({
                variables: {
                    organiserAdminUserIDs: organiserAdminUserIDs,
                },
            });
        }
        setShowDeleteNotifi(false);
        //this.setState(INITIAL_STATE);
    };

    const showDelNotifi = () => {
        if (selectedOrganiserAdminUsers.length > 0) {
            setShowDeleteNotifi(true);
        } else {
            let notify = new Notification();
            notify.setNotification(translate.t("ItemNotSelected"), "danger");
        }
    };

    if (getError || deleteError) {
        var error = getError ? getError : deleteError;
        const helper = new Helper();
        error = "ERROR: " + helper.getApolloErrorText(error);
    }
    return (
        <div>
            <div className="row">
                <div className="col-sm one">
                    <div className="card main">
                        <div className="card-header d-flex align-items-center">
                            {translate.t("OrganiserAdminUserList")}
                            <button className="btn btn-primary btn-thiner ml-auto" onClick={() => openCloseModal(true, "")}>
                                {translate.t("Add")}
                            </button>
                            <button className="btn btn-danger btn-thiner ml-2" onClick={() => showDelNotifi()}>
                                {translate.t("DeleteSelected")}
                            </button>
                        </div>
                        <div className="card-body">
                            {!error ? (
                                <div>
                                    <div className="data-list">
                                        <div className="data-list-item header">
                                            <div className="data-list-item-content">
                                                <div>{translate.t("Name")}</div>
                                                <div>{translate.t("Email")}</div>
                                                <div className="text-right">{translate.t("Options")}</div>
                                            </div>
                                        </div>
                                        <Fragment>
                                            {organiserAdminUserListData?.organiserAdminUsers?.map((item, index) => {
                                                var checked = false;
                                                for (let i in selectedOrganiserAdminUsers) {
                                                    if (selectedOrganiserAdminUsers[i] == item.organiserAdminUserID) checked = true;
                                                }

                                                return (
                                                    <div key={index} className="data-list-item-content">
                                                        <div>
                                                            {item.name} {item.surname}
                                                        </div>
                                                        <div>{item.email}</div>
                                                        <div className="text-right">
                                                            <input
                                                                className="delete-checked"
                                                                type="checkbox"
                                                                name="deleteOrganiserAdminUser[]"
                                                                checked={checked}
                                                                onChange={(e) => initiateDeleteOrganiserAdminUser(e, item.organiserAdminUserID)}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </Fragment>
                                    </div>
                                    {!loading ? (
                                        <Fragment>
                                            {!loading && (
                                                <>
                                                    {!organiserAdminUserListData?.organiserAdminUsers?.length && (
                                                        <NoItems text={translate.t("NoItemsAddedYet")} />
                                                    )}
                                                </>
                                            )}
                                        </Fragment>
                                    ) : (
                                        <Loading />
                                    )}
                                </div>
                            ) : (
                                <Fragment>{error && <Error text={error} />}</Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {showAdd && (
                <AddEditOrganiserAdminUser
                    openCloseModal={openCloseModal}
                    organiserAdminUserID={selectedOrganiserAdminUserID}
                    organiserID={props.organiserID}
                    updated={() => refetch()}
                />
            )}
            {showDeleteNotifi && <ModalNotification yesNo={true} text={translate.t("RemoveItems?")} callback={delOrganiserAdminUser} />}
        </div>
    );
};

export default OrganiserAdminUserList;
